import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProgressStore = defineStore('progress', () => {
    const eventMessage = ref(false)
    function setEventMessage(message) {
        eventMessage.value = message
    }
    function getEventMessage() {
        return eventMessage.value
    }
    return { setEventMessage, getEventMessage }
});
